import React, { useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  // NavItem,
  // NavLink,
} from "reactstrap";

const NavContainer = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className="stiky-bar">
      <Navbar color="white" light expand="md">
        <NavbarBrand
          href="/"
          style={{ fontWeight: "bolder" }}
          className="text-osperb flex-1 d-flex"
        >
          EdisonValley
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            {/* <NavItem>
              <NavLink className="text-white">Docs</NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="text-white">Examples</NavLink>
            </NavItem> */}
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default NavContainer;
